module.exports = __webpack_public_path__ + "fonts/Poppins-Light.b8b16412.woff2";